export default __webpack_public_path__ + "images/VJ.4121ecf.png";